/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../meevomessenger.component.base.ts" />

module Meevo.Plugins.MeevoMessenger {
    class TwoWaySmsController extends MessengerComponentBase {
        static $inject = [
            "$mdSidenav",
            "meevo.AppSettings",
            "meevo.components.common.BusinessInfoDataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.busy.BusyService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            "meevo.components.short-cuts.ShortCutsService",
            "$filter",
            "$translate",
            "$q",
            "meevo.plugins.meevoMessenger.meevoMessengerService",
            "meevo.plugins.meevoMessenger.meevoMessengerApiService",
            "$timeout",
            "meevo.components.common.SecurityService",
        ];

        public isClientOptedOut = false;

        //initialize base class variables
        intialSettingsSectionName = 'SECTION_TWO_WAY_SMS';
        undeleteConversationType = UndeleteConversationTypesEnum.TwoWaySms;
        messageLengthLimit = Meevo.Plugins.MeevoMessenger.Constants.MESSAGE_SMS_LENGTH_LIMIT;

        constructor(
            protected $mdSidenav: ng.material.ISidenavService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $filter: angular.IFilterService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService,
            protected meevoMessengerService: IMeevoMessengerService,
            protected meevoMessengerApiService: IMeevoMessengerApiService,
            protected $timeout: angular.ITimeoutService,
            protected securityChecker: Meevo.Components.Common.ISecurityService
        ) {
            super(
                $mdSidenav,
                appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                busyService,
                $rootScope,
                $scope,
                $state,
                contextParams,
                shortCutsService,
                $filter,
                $translate,
                $q,
                meevoMessengerService,
                meevoMessengerApiService,
                $timeout,
                MeevoMessengerClassificationAPI.TWOWAYSMS,
                securityChecker
            );

            this.notificationClassification = 'SMS';
        }

        initEventHandler(params) {
            // Call parent implementation first to keep existing subscriptions
            super.initEventHandler(params);

            // Add 2WaySms specific subscription
            this.$scope.$on(Meevo.Components.Common.Messages.TWO_WAY_SMS_MESSAGE_STATUS, (event: angular.IAngularEvent, msg: string) => {
                const msgData = JSON.parse(msg)
                this.changeMessageStatus(msgData);
            })

            this.$scope.$watch(() => this.selectedPhoneNumber, (phoneNumber) => {
                if (phoneNumber && phoneNumber.length == 10) {
                    const number = '+' + this.countryCode + phoneNumber
                    this.activateByUser(!this.isClientMessaging, number)
                }
            });
        }

        getOptOutStatus(): any {
            this.isClientOptedOut = false;

            const requestData = {
                phoneNumber: this.selectedConversation.phoneNumber,
                classification: this.defaultConversationBodyRequest.classification
            }

            this.meevoMessengerApiService.isClientOptedOut(requestData).then((isOptedOut: boolean) => {
                this.isClientOptedOut = isOptedOut;
            })
        }
    }


    class TwoWaySmsComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessenger/components/twoWaySms/index.html';
        controller = TwoWaySmsController;
        controllerAs = 'meevoMessenger';
        bindings: any = {
            isAccountInitialized: '=',
            isAutoReplyEnabled: '=',
            sideNavClientInfo: '=',
            isPulsing: '=',
            isClientMessaging: '=',
        };
    }

    angular.module('meevo.plugins.meevoMessenger')
        .component('twoWaySmsComponent', new TwoWaySmsComponent());

}
